/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // OPEN ALL EXTERNAL LINKS IN NEW TAB
  function targetBlank() {
    var internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");
    var a = document.getElementsByTagName("a"); // grab every link on the page
    for (var i = 0; i < a.length; i++) {
      var href = a[i].host; // set the host of shopify link
      if (!internal.test(href)) {
        // make sure the href of a element in loop doesn't contain current site's host
        a[i].setAttribute("target", "_blank"); // if it doesn't, set attribute
      }
    }
  }
  // Run the function targetBlank()
  targetBlank();

  // GSAP for image scaling on scroll
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    // Initial setup for hero images
    const wideImage = gsap.utils.toArray(".image__hero__scale img");
    wideImage.forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          trigger: el,
          scrub: true,
          toggleActions: "play pause resume pause",
        },
        scale: 1.5,
      });
    });

    // Separate setup for Instagram images with a delay
    setTimeout(() => {
      const instaImages = gsap.utils.toArray(".instafeed-new-layout-item img");
      instaImages.forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            scrub: true,
            toggleActions: "play pause resume pause",
          },
          scale: 1.5,
        });
      });
    }, 2000); // 2 second delay
  });

  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      let _self = this;
      let $product = _self.closest(".index-product");
      let p_url = new URL(window.location.href);
      let section_id = _self.dataset.section_id;
      let product_form = _self.parentElement.querySelector("product-form");
      let product_content = _self.parentElement.querySelector(".product__block--buttons");
      let product_formwrap = _self.parentElement.querySelector("product-form-wrap");
      console.log("product_content is " + product_content);

      // console.log(_self);

      this.PlayVideo();
      window.scrollTo(0, 0);
      setTimeout(this.FixMobile.bind(this), 0);

      $product.addEventListener("theme:variant:change", async (e) => {
        console.log(e);

        // Get product ID from current page
        let url_variant_id = new URLSearchParams(window.location.search).getAll(
          "variant"
        );
        console.log("url variant id " + url_variant_id);

        let is_newVariant = url_variant_id != e.detail.variant.id;
        if (is_newVariant) {
          p_url.searchParams.set("variant", e.detail.variant.id);
          let new_variant_url = `${p_url.href}&sections=${section_id}`;
          // console.log(section_id, new_variant_url);

          let res = await fetch(new_variant_url).then((res) => res.json());
          console.log(res);
          let res_media = res[section_id];

          let parser = new DOMParser();
          let doc = parser.parseFromString(res_media, "text/html");
          let $res = doc.body;

          // console.log($res, $res.querySelector('product-media'));

          _self.innerHTML = $res.querySelector("product-media").innerHTML;
          
          const new_content = $res.querySelector('product-form-wrap').innerHTML;
          product_formwrap.innerHTML = new_content;
      
          _self.PlayVideo();
          window.scrollTo(0, 0);
          setTimeout(this.FixMobile.bind(this), 250);

          // Reinitialize mobile slider logic
          initMobileSlider();

          hideSoldOutButton();
        }
      });
    }

    // PlayVideo() {
    //   console.log("Can play video?");
    //   let $btn_video = this.querySelector("[data-deferred-media-button]");
    //   if (!$btn_video) return;
    //   console.log("Yes, can play video");
    //   $btn_video.dispatchEvent(new Event("click"));
    // }

    PlayVideo() {
      console.log("Checking for videos…");

      // Find ALL video/button triggers inside this section
      const buttons = this.querySelectorAll("[data-deferred-media-button]");
      if (!buttons.length) return;

      console.log(`Found ${buttons.length} video(s). Playing…`);

      buttons.forEach((btn) => {
        btn.dispatchEvent(new Event("click"));
      });
    }

    FixMobile() {
      this.querySelector(".product__slides").classList.add("remove-overflow");
    }
  }
  customElements.define("product-media", ProductMedia);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// Move the mobile slider logic into a reusable function
function initMobileSlider() {
  console.log("Init mobile slider");

  let startX = 0;
  let isDragging = false;
  const slider = document.querySelector(".product__slides");
  const videos = document.querySelectorAll(".media-video");
  const thumblinks = document.querySelectorAll(".product__thumb__link");

  function playVisibleVideo() {
    if (isDesktop()) {
      videos.forEach((video) => {
        video.play();
        window.scrollTo(0, 0);
      });
    } else {
      videos.forEach((video) => {
        if (video.closest(".media--active")) {
          video.play().catch((error) => console.log("Autoplay failed:", error));
        } else {
          video.pause();
        }
      });
    }
  }

  function isDesktop() {
    return window.innerWidth > 750;
  }

  if (slider) {
    slider.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    slider.addEventListener("touchmove", () => {
      isDragging = true;
    });

    slider.addEventListener("touchend", () => {
      if (isDragging) {
        setTimeout(playVisibleVideo, 200);
      }
      isDragging = false;
    });

    slider.addEventListener("mousedown", (e) => {
      startX = e.clientX;
      isDragging = true;
    });

    slider.addEventListener("mouseup", () => {
      if (isDragging) {
        setTimeout(playVisibleVideo, 200);
      }
      isDragging = false;
    });
  }

  thumblinks.forEach((thumbnail) => {
    thumbnail.addEventListener("click", function (event) {
      const mediaId = this.getAttribute("data-media-id");
      if (!mediaId) return;

      const targetSlide = document.querySelector(
        `.product__slide[data-media-id="${mediaId}"]`
      );
      if (targetSlide) {
        const deferredMedia = targetSlide.querySelector("deferred-media");
        if (deferredMedia && !deferredMedia.hasAttribute("loaded")) {
          deferredMedia.setAttribute("loaded", "true");
        }

        const video = targetSlide.querySelector(".media-video");
        if (video) {
          video.play().catch((error) => console.log("Autoplay failed:", error));
        }
      }
    });
  });

  playVisibleVideo();

  window.addEventListener("resize", function () {
    playVisibleVideo();
  });
}

function hideSoldOutButton() {
  const soldOutBtn = document.querySelector("button[data-add-to-cart]");
  const notifyBtn = document.querySelector("button.btn--notify");

  if (notifyBtn && notifyBtn.offsetParent !== null) {
    soldOutBtn.style.display = "none";
  }
}

// QUICKADD: Klaviyo pop up triggered by button click
function joinWaitlist(formID) {
    console.log("Waitlist", formID);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formID ]);
}

if (!customElements.get('product-form-wrap')) {
  customElements.define('product-form-wrap', class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      console.log(this);
      let $quick_add = this.closest('.product-quick-add');
      if (!$quick_add) return;

      $quick_add.addEventListener('theme:variant:change', (e) => {
        // console.log(e);

        // Quickadd for Waitlist
        console.log("quickadd variant change");
        let $variant_kform = this.querySelector(`[data-kforms] [data-variant_id="${ e.detail.variant.id }"]`);
        // console.log($variant_kform);
        let $btn_add = this.querySelector('[data-add-to-cart]');          
        $btn_add.style.display = 'block';
        if ($variant_kform) {
          let kform_id = $variant_kform.dataset.kform;
          $btn_add.insertAdjacentHTML('afterend', `<button class="btn btn--secondary" data-join-waitlist onclick="joinWaitlist('${kform_id}'); return false;">Notify me when available</button>`);
          $btn_add.style.display = 'none';
        }
        else {
          let $btn_waitlist = this.querySelector('[data-join-waitlist]');
          if ($btn_waitlist) {
            $btn_waitlist.remove();
          }
        }

        // Quickadd for variant preorder 
        let $variant_preorder = this.querySelector(`[data-variant-preorders] [data-variant_id="${ e.detail.variant.id }"]`);
        
        // Always remove old preorder input if exists
        let $existing_preorder_input = this.querySelector('[data-variant-preorder]');
        let $existing_preorder_message = this.querySelector('.preorder-text');
        
        if ($existing_preorder_input) $existing_preorder_input.remove();
        if ($existing_preorder_message) $existing_preorder_message.remove();

        if ($variant_preorder) {
          let preorder_text = $variant_preorder.dataset.preorderText;

          // Change button text to Preorder
          let $btn_text = this.querySelector('[data-add-to-cart-text]');
          $btn_text.textContent = "Preorder";

          // Insert preorder messaging above button
          $btn_add.insertAdjacentHTML(
            'afterend',
            `<p class="preorder-text">${preorder_text}</p>`
          );
          
          // Insert hidden preorder field
          $btn_add.insertAdjacentHTML(
            'beforebegin',
            `<input 
              type="hidden"
              name="properties[Preorder]" 
              value="${preorder_text}"
              data-variant-preorder
            >`
          );
        } else {
          // Reset button text
          $btn_text.textContent = "Add to cart";
        }
      });
    }
  });
}


/*** Cart update ***/
// Reload cart upsell for BF2025 Gift With Purchase
document.addEventListener('DOMContentLoaded', function() { 
  console.log("theme cart change code block ready");
  document.addEventListener('theme:cart:change', getCartWidget);
});

async function getCartWidget() {
  try {
    console.log("bfgwp");

    // Get cart widget
    const response = await fetch('/?sections_id={{ section.id | json }}');
    const htmlText = await response.text();
    const parser = new DOMParser();
    const html = parser.parseFromString(htmlText, 'text/html');
    console.log(html.querySelector('.cart__widget--products'));

    // Then look for your element inside it
    const newElement = html.querySelector('.cart__widget--products');
    console.log("new element:", newElement);
    
    // Get the existing element on the page
    const existingElement = document.querySelector('.cart__widget--products');
    console.log("old element:", existingElement);
    
    // Replace the content
    if (newElement && existingElement) {
      existingElement.innerHTML = newElement.innerHTML;
      console.log('Cart widget updated!');
    } else {
      console.log('Element not found', { newElement, existingElement });
    } 

    // Update subtotal
    // const newPriceElement = html.querySelector('.cart__foot__inner');
    // console.log("new element:", newPriceElement);
    
    // // Get the existing element on the page
    // const existingPriceElement = document.querySelector('.cart__foot__inner');
    // console.log("old element:", existingPriceElement);
    
    // // Replace the content
    // if (newPriceElement && existingPriceElement) {
    //   existingPriceElement.innerHTML = newPriceElement.innerHTML;
    //   console.log('Cart price updated!');
    // } else {
    //   console.log('Element not found', { newPriceElement, existingPriceElement });
    // } 
    

  } catch (error) {
    console.log("error bfgwp");
  }
}


document.addEventListener('alpine:init', () => {
  Alpine.data('FreeGiftWithPurchase', () => ({
    cart: null,
    eligible: 0,
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      let cart = JSON.parse(this.$el.dataset.cart);
      let eligible = parseFloat(this.$el.dataset.eligible);
      this.cart = cart;
      this.eligible = eligible;
    },
    InitWatchers() {

    }
  }));

  Alpine.data('LineItemQuantityCounter', () => ({
    line_item: null,
    quantity: 1,
    init() {
      this.InitSelf();
      this.InitWatchers();
    },
    InitSelf() {
      let line_item = JSON.parse(this.$el.dataset.line_item);
      this.line_item = line_item;
      this.quantity = line_item.quantity;
    },
    InitWatchers() {
      let $self = this.$el;
      const input = this.$el.querySelector('.quantity__input');

      // Prevent Enter key from submitting the form
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation();
          input.blur(); // optional: trigger blur to update value visually
        }
      });
      
      // Watch for changes to the quantity input
      this.$el.addEventListener('click', this.UpdateQuantityValue.bind(this));
      this.$el.querySelector('.quantity__input').addEventListener('change', this.UpdateQuantityValue.bind(this));

      // update cart item
      this.$watch('quantity', async() => {
        // Update the cart item quantity so it triggers cart update events
        let $cartItem = document.querySelector(`.cart__item[data-item="${this.line_item.key}"]`);
        $cartItem.dispatchEvent(new CustomEvent('theme:cart:update', {
          detail: {
            id: $cartItem.dataset.itemIndex,
            quantity: this.quantity
          }
        }));
      });
    },
    UpdateQuantityValue() {
      let new_quantity = parseInt(this.$el.querySelector('.quantity__input').value);
      if (new_quantity < 0 || isNaN(new_quantity) || new_quantity === this.quantity) return;
      this.quantity = new_quantity;
    }
  }));
});

